var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navdrawer',{on:{"offCanvasMain":_vm.offCanvasMain}}),_c('v-expand-x-transition',[_c('v-main',{class:[_vm.addMargin ? 'aMargin' : 'mMargin']},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }